export const MODEL_TRAINING_STATUS_TRAINED = 'TRAINED'
export const MODEL_TRAINING_STATUS_TRAINING = 'TRAINING'
export const MODEL_TRAINING_STATUS_TRAINING_ERROR = 'TRAINING_ERROR'
export const MODEL_TRAINING_STATUS_NEEDS_TRAINING = 'NEEDS_TRAINING'

export const MODEL_TRAINING_STATUS_PUBLISHING = 'PUBLISHING'
export const MODEL_TRAINING_STATUS_PUBLISHED = 'PUBLISHED'
export const MODEL_TRAINING_STATUS_ERROR = 'ERROR'
